import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appPhoneMask]'
})
export class PhoneMaskDirective {

  constructor(
    private model: NgControl
  ) { }

  @HostListener('ngModelChange') ngModelChange() {
    this.modelValue();
  }

  @HostListener('keydown.backspace') onKeyDownBackspace() {
    this.modelValue(true);
  }

  private modelValue(backspace?: boolean) {
    if (this.model) {
      var model: any = this.model;
      if(model.viewModel) {
        if (typeof model.viewModel === 'number') {
          model.viewModel = model.viewModel.toString();
        }
        this.inputChange(model.viewModel, backspace);
      }
    }
  }

  private inputChange(model: any, backspace?: any) {
    if (model) {
      var newVal = model.replace(/\D/g, '');

      if (backspace) {
        if(newVal.length === 1){
          newVal = newVal.substring(0, newVal.length - 1);
        }
      }

      if (newVal.length == 0) {
        newVal = '';
      } else if (newVal.length === 1) {
        newVal = newVal.replace(/(\d{1})/, "($1");
      } else if (newVal.length === 2) {
        newVal = newVal.replace(/(\d{2})/, "($1)");
      } else if (newVal.length <= 6) {
        newVal = newVal.replace(/(\d{2})(\d{0,4})/, "($1) $2");
      } else if (newVal.length <= 10) {
        newVal = newVal.replace(/(\d{2})(\d{0,4})(\d{0,4})/, "($1) $2-$3");
      } else if (newVal.length <= 11) {
        newVal = newVal.replace(/(\d{2})(\d{0,5})(\d{0,4})/, "($1) $2-$3");
      }

      this.model.valueAccessor.writeValue(newVal);
    }
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/shared/directives/phone-mask.directive.ts
 **/